import React from 'react';

const WarningModal = ({ 
  showWarningModal,
  warningMessage,
  tabSwitchCount
}) => {
  if (!showWarningModal) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 border-4 border-red-500 animate-pulse">
        <div className="flex items-center gap-4 mb-4">
          <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
            <svg className="h-6 w-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <h3 className="text-2xl font-bold text-red-700">Warning!</h3>
        </div>
        
        <p className="text-gray-800 text-lg font-semibold mb-4">
          {warningMessage}
        </p>

        {tabSwitchCount >= 5 && (
          <p className="text-red-700 font-bold text-center">
            Your exam will be submitted in 3 seconds...
          </p>
        )}
      </div>
    </div>
  );
};

export default WarningModal;
